if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
  document.documentElement.classList.add('safari-browser');
}


setTimeout(() => {
  if(document.querySelector(".shopify-section-group-footer-group") != null){
    let footer_height = document.querySelector(".shopify-section-group-footer-group").offsetHeight;
    document.documentElement.style.setProperty('--bs-footer-height', `${footer_height}px`);
  }
}, 2000);

// Header height management
function updateHeaderHeights() {
  try {
    const root = document.documentElement;
    let totalHeaderHeight = 0;
    let totalTopbarHeight = 41;
    let totalMainHeaderHeight = 69;

    // Update section header height
    const sectionHeader = document.querySelector('.site-header');
    if (sectionHeader) {
      const topbarHeight = sectionHeader.clientHeight;
      root.style.setProperty('--bs-header-height', `${topbarHeight}px`);
      totalHeaderHeight += topbarHeight;
    }

    // Update topbar height
    const topbar = document.querySelector('.topbar');
    if (topbar) {
      const topbarHeight = topbar.clientHeight;
      root.style.setProperty('--bs-topbar-height', `${topbarHeight}px`);
      totalHeaderHeight += topbarHeight;
    }

    // Update main header height
    const mainHeader = document.querySelector('.main-header');
    if (mainHeader) {
      const mainHeaderHeight = mainHeader.clientHeight;
      root.style.setProperty('--bs-mainHeader-height', `${mainHeaderHeight}px`);
      totalHeaderHeight += mainHeaderHeight;
    }

    // Set the total combined header height
    root.style.setProperty('--bs-total-header-height', `${totalHeaderHeight}px`);

  } catch (error) {
    console.error('Error updating header heights:', error);
  }
}
updateHeaderHeights();

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      // if (type === 'click' || type === 'touchend') {
      if (type === 'click') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.preventDefault();
          this.toggleDropdown();
        });
        // this.toggleCTA.addEventListener(type, (_evt) => {
        //       this.childOnFocusChange(this.dropdown);
        //     });
      } 
      // else if(type === 'mouseenter') {
      //   this.toggleCTA.addEventListener(type, (evt) => {
      //       this.dropdownShow(this.dropdown);
      //   });
      //   this.toggleCTA.addEventListener(type, (_evt) => {
      //     this.childOnFocusChange(this.dropdown);
      //   });
      // } else if(type === 'mouseleave') {
      //   this.dropdown.addEventListener(type, (evt) => {
      //     this.dropdownHide(this.dropdown);
      //   });
      // } else if(type == 'focusout'){
      //   this.dropdown.addEventListener(type, (evt) => {
      //     if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
      //       this.dropdownHide(this.dropdown);
      //     }
      //   });
      // }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    if(dropdownParent.hasAttribute('data-second-level')){
      document.querySelectorAll('.navbar-mobile [data-second-level]').forEach((ele) => {
        ele.classList.remove('open');
      });
    }
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');
    
    // Store observer instance on the element itself
    this.autoplayObserver = null;
    this.hasAutoplayTriggered = false;
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
    // Clean up observer when element is removed
    if (this.autoplayObserver) {
      this.autoplayObserver.disconnect();
      this.autoplayObserver = null;
    }
    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
      this.scrollObserver = null;
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true') this.autoplayOnInit();
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? this.openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        this._playVideo(videoElement);
        if (this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);

        if(this.querySelector("[data-video-btn]") != null){
          this.querySelector("[data-video-btn]").addEventListener("click", (event) => {
            let videoTarget = event.target.closest("custom-video").querySelector("video");
            if (videoTarget.paused) {
              this._playVideo(videoTarget);
              this.container.classList.remove("video-play");
            } else {
              this._pauseVideo(videoTarget);
              this.container.classList.add("video-play");
            }
          });
        }

        if(this.querySelector("[data-video-sound-btn]") != null){
          this.querySelector("[data-video-sound-btn]").addEventListener("click", (event) => {
            let videoTarget = event.target.closest("custom-video").querySelector("video");
            videoTarget.muted = !videoTarget.muted;
            this.container.classList.toggle("video-unmuted", !videoTarget.muted);
          });
        }
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=${this.dataset.autoplay == 'true' ? 1 : 0}&muted=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  /**
   * Check if element is actually visible (not just in DOM)
   */
  isActuallyVisible() {
    const rect = this.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Check if element is in viewport
    const inViewport = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= viewportHeight &&
      rect.right <= viewportWidth
    ) || (
      rect.top < viewportHeight &&
      rect.bottom > 0 &&
      rect.left < viewportWidth &&
      rect.right > 0
    );
    
    // Check if element is not hidden by parent (for Swiper slides)
    const style = window.getComputedStyle(this);
    const parentStyle = this.parentElement ? window.getComputedStyle(this.parentElement) : null;
    
    const isVisible = style.display !== 'none' && 
                     style.visibility !== 'hidden' && 
                     style.opacity !== '0' &&
                     (!parentStyle || (parentStyle.display !== 'none' && parentStyle.visibility !== 'hidden'));
    
    // Check if inside active Swiper slide
    const swiperSlide = this.closest('.swiper-slide');
    const isActiveSlide = !swiperSlide || swiperSlide.classList.contains('swiper-slide-active');
    
    return inViewport && isVisible && isActiveSlide;
  }

  /**
   * Autoplay video when element enters viewport
   */
  autoplayOnInit(element = this){
    if(window.innerWidth <= 768){
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5 // Require at least 50% visibility
      };

      this.autoplayObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Only trigger if truly visible and hasn't been triggered yet
          if(entry.isIntersecting && entry.intersectionRatio >= 0.5 && !this.hasAutoplayTriggered) {
            // Additional check for Swiper slides
            if(this.isActuallyVisible()) {
              this.hasAutoplayTriggered = true;
              
              setTimeout(() => {
                this.toggleView();
              }, 100);
            }
          }
        });
      }, observerOptions);
      
      this.autoplayObserver.observe(this);
    }else{
      const elementIntersection = (entries) => {
        if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
          element.toggleView();
          observeElement.disconnect();
        }
      };
      let observeElement = new IntersectionObserver(elementIntersection);
      observeElement.observe(element);
    }
  }
}

customElements.define("custom-video", CustomVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if(btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }, 500);
        }else{
          if(evt.currentTarget.hasAttribute("data-desktop-link")){
            this.openDrawer(evt.currentTarget);
          } else {
            (this.isOpen)? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }          
        }
        
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    // this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if(evt.code && evt.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    document.querySelectorAll(".navbar-main .desktop-navbar .navbar-nav > .nav-item.dropdown").forEach((ele) => ele.classList.remove('open'));
    this.isOpen = true;
    this.openedBy = opener || null;
    
    setTimeout(() => {
      if (opener?.hasAttribute("data-desktop-link")) {
        document.querySelectorAll(".navbar-mobile .nav-item.dropdown").forEach((ele) => ele.classList.remove('open'));
        const title = opener.getAttribute("title");
        document.querySelectorAll(".navbar-mobile .nav-item.dropdown").forEach((ele) => {
          if (ele.getAttribute('data-title') == title) {
            ele.classList.add('open');
          }
        });
      }
    }, 100);

    // setTimeout(() => {
      this.classList.add('open');
      this.setAttribute('aria-hidden', 'false');
    // }, 500);
    
    
    this.openedBy?.setAttribute('aria-expanded', true);

    // Check if drawer is visible before showing overlay (handles CSS-hidden drawers like search on mobile)
    const drawerStyle = window.getComputedStyle(this);
    const isDrawerVisible = drawerStyle.display !== 'none';
    
    if (isDrawerVisible) {
      SiteOverlay.prototype.showOverlay();
    }
    
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
  }

  closeDrawer(evt) {    
      this.isOpen = false;

      if (evt?.currentTarget.hasAttribute("data-dropdown-close") || window.innerWidth >= 992) {
        document.querySelectorAll(".navbar-mobile .nav-item.dropdown").forEach((ele) => ele.classList.remove('open'));
        document.querySelector(".nav-item.open")?.classList.remove('open');

      }else{
        if(document.querySelectorAll(".navbar-mobile .open").length){
          document.querySelectorAll(".navbar-mobile .open").forEach((ele) => ele.classList.remove('open'));
        }
      }

      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      setTimeout(() => {
        this.classList.remove('collection-sorting');
      }, 500);
      

      SiteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

// Fix iPhone zoom issue
if (navigator.userAgent.includes('iPhone')) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
  }
}

/* Animation parallax JS */
const parallax = document.querySelectorAll('[parallax-image-animation] .parallax-image');
const speed = 0.5;

window.onscroll = function () {
  parallax.forEach(function (el) {
    let topOffset = el.getBoundingClientRect().top + window.scrollY;
    const dist = window.scrollY - topOffset;
    el.style.top = (dist * speed) + 'px';
  });
};
/* Animation parallax JS */


(() => {
  class CustomReadMore extends HTMLElement {
      constructor() {
          super();
      }

      connectedCallback() {
          this.content = this.querySelector(".read-more-content");
          this.link = this.querySelector(".read-more-link");
          this.linkText = this.link.querySelector("span");
          this.maxHeight = this.dataset.maxheight;
          this.isExpanded = false;

          // Delay to allow rendering and fonts to load
          setTimeout(() => {
              this.updateLinkVisibility();
          }, 100);

          this.link.addEventListener("click", (e) => {
              e.preventDefault();
              this.toggleContent();
          });
      }

      updateLinkVisibility() {
          const scrollHeight = this.content.scrollHeight;
          const clientHeight = this.content.clientHeight;
          if (scrollHeight > clientHeight) {
              this.link.classList.remove("d-none");
          } else {
              this.link.classList.add("d-none");
          } 
      }

      toggleContent() {
          this.isExpanded = !this.isExpanded;
          this.linkText.innerText = this.isExpanded ? "less" : "more";
          this.content.classList.toggle("expand", this.isExpanded);
      }
  }

  // Avoid redefining the element
  if (!customElements.get("custom-read-more")) {
      customElements.define("custom-read-more", CustomReadMore);
  }
})();

if(document.querySelector("[data-searct-term-remove]") != null){
  document.querySelector("[data-searct-term-remove]").addEventListener("click", (e) => {
    e.preventDefault();
    const searchInput = document.querySelector('.search-form-control');
    if (searchInput) {
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input'));
      document.querySelector("[data-searct-term-remove]").classList.add("d-none");
    }
  });
  document.querySelector("#Search-In-Modal").addEventListener("keyup", (e) => {
      if(e.target.value.length > 0){
        document.querySelector("[data-searct-term-remove]").classList.remove("d-none");
      }else{
        document.querySelector("[data-searct-term-remove]").classList.add("d-none");
      }
  });

}

if(document.querySelectorAll("[data-search-suggestion]").length > 0){
  document.querySelectorAll("[data-search-suggestion]").forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      let target = e.target;
      if(!target.hasAttribute("data-search-input")){
        target = target.closest("[data-search-input]");
      };
      const searchInput = document.querySelector('.search-form-control');
      if (searchInput) {
        searchInput.value = target.getAttribute("data-search-input");
        searchInput.dispatchEvent(new Event('input'));
      }
    });
  });
}


// Infinite scroll load more button trigger on visible
if(document.querySelector("[data-loadmore]") != null){
  var win = window;
  win.addEventListener('scroll',(event) => {
    const loadMoreButton = document.querySelector("[data-loadmore]");
    if (loadMoreButton) {
        const rect = loadMoreButton.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        if (isVisible) {
          if(!loadMoreButton.classList.contains("loading")){
            loadMoreButton.click();
          }
        }
    }
  });
}

// Condition 1: Direct iPhone check via userAgent
if (/iPhone/i.test(navigator.userAgent)) {
  document.body.classList.add("ios-detected");
}

// Condition 2: Basic iOS (iPhone, iPad, iPod)
else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  document.body.classList.add("ios-detected");
}

// Condition 3: iPadOS 13+ identifies as Mac but has touch
else if (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1) {
  document.body.classList.add("ios-detected");
}

// Condition 4: Safari Browser (but NOT Chrome, NOT Firefox)
else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  document.body.classList.add("ios-detected");
}
